/* @flow */

export default class CloseLeadRequest {
    companyId: number;
    leadId: number;
    leadLostReasonDetailId: number;
    lostToCompetitor: string;
    endOfContract: moment;
  }
  